import { apiResourceUrl } from "@ploy-lib/core";
import { BaseResource } from "./BaseResource";
export var LandingPageStatusEnum;
(function (LandingPageStatusEnum) {
    LandingPageStatusEnum[LandingPageStatusEnum["MissingContactInfo"] = -1] = "MissingContactInfo";
    LandingPageStatusEnum[LandingPageStatusEnum["NotSent"] = 0] = "NotSent";
    LandingPageStatusEnum[LandingPageStatusEnum["Sent"] = 1] = "Sent";
    LandingPageStatusEnum[LandingPageStatusEnum["Completed"] = 2] = "Completed";
})(LandingPageStatusEnum || (LandingPageStatusEnum = {}));
export class LandingPageStatusesResource extends BaseResource {
    pk() {
        return this.shortReference;
    }
    static distribute() {
        return super.create().extend({
            url: () => apiResourceUrl("landing-page/distribute-landing-page")
        });
    }
}
LandingPageStatusesResource.urlRoot = apiResourceUrl("landing-page/statuses/{applicationId}");
//# sourceMappingURL=KycLandingPageStatusResources.js.map